<template>
    <div :class="['alert', `alert-${type}`]" data-test-id="l-text-alert">{{ text }}</div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "info",
            validator: value => ["info", "success", "warning", "danger"].includes(value),
        },
        text: {
            type: String,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
